export default __webpack_public_path__ + "locales/pl/DowngradePlanDialog.json?hash=3d299a245b191ffa2dfe938ec8e1d862";